import { useCheckPermission } from "@/hook/use-check-permission"
import { useEffect, useState } from "react"
import { MediaFolder } from "../../../../lib/config/types"
import { mediaFolderList } from "../services/media-folder-services"

// Ô "Search Media" tìm cả thư mục (giống CMS cũ): gọi song song API folder
// (GET /folders?search=, lọc tên chứa từ khoá trên toàn thư viện) bên cạnh API
// media. FolderSelector dùng kết quả này thay cho danh sách folder con khi đang search.
export function useFolderSearch(searchTerm: string | undefined, domain?: string) {
  const { hasPermission } = useCheckPermission()
  const canGetFolders = hasPermission("media", "getFolders")
  const active = !!searchTerm && canGetFolders
  const [folders, setFolders] = useState<MediaFolder[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!active) {
      setFolders([])
      setLoading(false)
      return
    }
    // Bỏ response cũ khi gõ tiếp / đổi site trước khi request trước trả về.
    let cancelled = false
    setLoading(true)
    mediaFolderList(undefined, searchTerm, domain)
      .then(resp => {
        if (!cancelled) setFolders(Array.isArray(resp?.data) ? resp.data : [])
      })
      .catch(() => {
        if (!cancelled) setFolders([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [active, searchTerm, domain])

  return { active, folders, loading }
}
